import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';

class ServiceDetails extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'
        let imagealt = 'image'

        return	<section className="service-details">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 clearfix">
                        <img src={publicUrl+"assets/images/resources/social-media-chatbot.jpg"} alt={ imagealt } className="float-right wow fadeInLeft" data-wow-duration="1500ms" />
                    </div>{/* /.col-lg-6 */}
                    <div className="col-lg-6">
                        <div className="service-details__content">
                            <h3>Engage customers where they <br/> already spend their time.</h3>
                            <p>Connect your AI Chat Agent directly with popular social platforms like WhatsApp, Facebook Messenger, Instagram, and more, allowing your business to engage customers instantly on the channels they already use every day.</p>
                            <p>From answering questions to capturing leads and processing inquiries, your Chat Agent ensures fast, consistent, and automated communication across all platforms without missing a single message.</p>

                        </div>{/* /.service-details__content */}
                    </div>{/* /.col-lg-6 */}
                </div>{/* /.row */}
                <div className="row">
                    <div className="col-lg-6">
                        <img src={publicUrl+"assets/images/resources/service-detail-22.jpg"} alt={ imagealt } className="wow fadeInRight" data-wow-duration="1500ms" />
                    </div>{/* /.col-lg-6 */}
                    <div className="col-lg-6">
                        <div className="service-details__content">
                            <h3>What You Get</h3>
                            <ul className="list-unstyled service-details__list">
                                <li>
                                    Real-time automated replies across social platforms
                                </li>
                                <li>Lead capture directly from chats</li>
                                <li>Personalized responses based on user behavior</li>
                                <li>24/7 availability without manual effort</li>
                                <li>Centralized dashboard for all conversations</li>
                            </ul>{/* /.list-unstyled service-details__list */}
                        </div>{/* /.service-details__content */}
                    </div>{/* /.col-lg-6 */}
                </div>{/* /.row */}
                <div className="row">
                    <div className="col-lg-6 clearfix">
                        <img src={publicUrl+"assets/images/resources/unified-conversations.jpg"} alt={ imagealt } className="float-right wow fadeInLeft" data-wow-duration="1500ms" />
                    </div>{/* /.col-lg-6 */}
                    <div className="col-lg-6">
                        <div className="service-details__content">
                            <h3>Unified Conversations, Better Conversions</h3>
                            <p className="mb-3">Streamline your customer interactions by managing all social conversations through a single intelligent system. Deliver quick responses, maintain consistent messaging, and turn casual inquiries into valuable business opportunities.</p>

                            <h4 className="mb-4">What It Delivers</h4>
                            <ul className="list-unstyled service-details__list">
                                <li>
                                    Respond instantly to customer queries
                                </li>
                                <li>Handle multiple conversations simultaneously
                                </li>
                                <li>Generate and qualify leads from social traffic
                                </li>
                                <li>Improve engagement and customer satisfaction</li>
                                <li>Reduce manual workload for your team</li>
                            </ul>{/* /.list-unstyled service-details__list */}

                            <h5 className="mb-4 mt-4">Supported Platforms: Maybe use icons instead of this</h5>
                            <ul className="list-unstyled service-details__list">
                                <li>
                                    WhatsApp
                                </li>
                                <li>Instagram
                                </li>
                                <li>Facebook Messenger
                                </li>
                            </ul>
                        </div>{/* /.service-details__content */}
                    </div>{/* /.col-lg-6 */}
                </div>{/* /.row */}
            </div>{/* /.container */}
        </section>

    }
}

export default ServiceDetails